import React from 'react';
import TrendVolumeResult from './TrendVolumeResult';
import TrendDetailOptionBar from './TrendDetailOptionBar';

const TrendDetailMain = (props) => {

  return (
    <>
      <TrendDetailOptionBar handleDateBtn={props.handleDateBtn} onDateBtn={props.onDateBtn} dateRange={props.dateRange} handleDate={props.handleDate} minDate={props.minDate}
        // handleTrendQuery={props.handleTrendQuery} trendQuery={props.trendQuery}
        handleTimeUnitBtn={props.handleTimeUnitBtn} onTimeUnitBtn={props.onTimeUnitBtn}
        handleRunBtn={props.handleRunBtn}
        handleSelectionChange={props.handleSelectionChange}
        handleQueryChange={props.handleQueryChange} trendQueries={props.trendQueries}
        handleAddQuery={props.handleAddQuery} handleRemoveQuery={props.handleRemoveQuery}
      />
      <div className="row featured-main">
        <TrendVolumeResult data={props.resultData} onTimeUnitBtn={props.onTimeUnitBtn} userRole={props.userRole} />
      </div>
    </>
  )
}

export default TrendDetailMain;